// Target URL for a moved route: `:param` segments are filled (encoded) from
// the old URL's params, and the old query and hash are appended; query keys
// the target sets itself win over the old ones.
export const buildRedirectTarget = (to, params = {}, search = "", hash = "") => {
  const filled = to.replace(/:([A-Za-z_]+)/g, (_, key) =>
    encodeURIComponent(params[key] ?? ""),
  );
  const [pathname, targetQuery = ""] = filled.split("?");
  const query = new URLSearchParams(targetQuery);
  const fixed = new Set(query.keys());
  new URLSearchParams(search).forEach((value, key) => {
    if (!fixed.has(key)) query.append(key, value);
  });
  const qs = query.toString();
  return `${pathname}${qs ? `?${qs}` : ""}${hash || ""}`;
};
